import React from "react"
import Cabecalho from "../Cabecalho"
import { IntegracaoWhatsappForm } from "./components/IntegracaoWhatsappForm"

export function IntegracaoWhatsapp() {
    return (
        <>
            <Cabecalho pagina="Integração WhatsApp Business API" />
            <IntegracaoWhatsappForm />
        </>
    )
}
